<template>
  <div class="RscWarehousing">
    <!-- Rsc 入库单 -->
    <div
      style="display: flex; justify-content: space-between; align-items: center"
      v-if="type === 'true'"
    >
      <van-button
        type="info"
        size="small"
        style="display: flex"
        :text="ray"
        @click="holdRay()"
      ></van-button>
      <div>
        <input
          id="scanQRCode"
          ref="getIDInpot"
          @keyup.enter="add_mx()"
          v-model="add_data"
          readonly
          style="height: 20px; width: 96px"
          autocomplete="off"
        />
        <input
          ref="getIDInpot2"
          @keyup.enter="warehousing()"
          v-on:blur="hideMessage()"
          v-model="mxm"
          readonly
          style="height: 20px; width: 96px"
          autocomplete="off"
        />
      </div>
    </div>

    <div :style="style">
      <div class="goods-info-two" v-for="(i, index) in w_data" :key="index">
        <div style="width: 100%; text-align: right">
          <van-icon
            name="cross"
            @click="deleteData(index)"
            style="margin: 5px 5px 5px 0"
          />
        </div>
        <div class="info-order-h">
          <div style="width: 50%; display: flex; align-items: center">
            <div class="right-twenty">货号</div>
            <div class="data-order">{{ i.goods_number || i.number }}</div>
          </div>
          <div style="width: 50%; display: flex; align-items: center">
            <div class="right-twenty">产品名称</div>
            <div class="data-order">{{ i.goods_name || i.name }}</div>
          </div>
        </div>
        <div class="info-order-h">
          <div style="width: 50%; display: flex; align-items: center">
            <div class="right-twenty">供应商型号</div>
            <div class="data-order">{{ i.supplier_xh }}</div>
          </div>
          <div style="width: 50%; display: flex; align-items: center">
            <div class="right-twenty">明细码</div>
            <div class="data-order">{{ getnumber(i.gck_number) }}</div>
          </div>
        </div>
        <div class="sp-db-h">
          <div class="right-twenty">规格</div>
          <div class="data-order">{{ i.goods_normtype || i.size }}</div>
        </div>
        <div class="info-order-h">
          <div style="width: 50%; display: flex">
            <div class="right-twenty">卷号</div>
            <div class="data-order">{{ i.reel }}</div>
          </div>
          <div style="width: 50%; display: flex">
            <div class="right-twenty">卷号描述</div>
            <div class="data-order">{{ i.reel_detail }}</div>
          </div>
        </div>
        <div class="info-order-h">
          <div style="width: 50%; display: flex">
            <div class="right-twenty">数量</div>
            <div class="data-order">
              <input
                v-if="type === 'true'"
                v-model="i.goods_count"
                v-on:blur="countAll()"
                style="width: 2rem"
              />
              <span v-else>{{ i.goods_count }}</span>
            </div>
          </div>
          <div style="width: 50%; display: flex">
            <div class="right-twenty">计量单位</div>
            <div class="data-order">{{ i.unit }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="filling-goods-bottom">
      <van-button type="warning" class="bottom-button" @click="go_index()">
        回首页
      </van-button>
      <van-button
        type="info"
        v-if="type === 'true'"
        @click="warehous"
        class="bottom-button"
      >
        确认入库
      </van-button>
      <van-button type="warning" @click="reload()">新建</van-button>
      <van-button type="info" class="bottom-button" @click="toInboundScanning()"
        >入箱扫码</van-button
      >
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import { get, post } from "@/utils/request";
import { config } from "process";
export default {
  name: "RscWarehousing",
  data() {
    return {
      ray: "已暂停，点击我继续扫码",
      add_data: "",
      all_data: [],
      w_data: [],
      mxm: "",
      style: "",
      type: "true",
      ware_type: 0,
      belong: "",
      getnumber: (i) => {
        if (i.indexOf("-") === -1) {
          return i;
        } else {
          return i.substr(0, i.indexOf("-"));
        }
      },
    };
  },
  mounted() {
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.style =
      "text-align: left;width: 100%;height: " + h * 0.78 + "px;overflow:scroll";

    this.holdRay();
  },
  methods: {
    toInboundScanning() {
      this.$router.push({
        path: "/inboundScanning",
      });
    },
    go_index() {
      //回到首页
      Dialog.confirm({
        message: "确定要回首页吗？",
      })
        .then(() => {
          this.$router.push("/home");
        })
        .catch(() => {
          // on cancel
        });
    },
    reload() {
      window.location.reload();
    },
    warehous() {
      // 出库的方法
      Dialog.confirm({
        message: "确认要入库吗",
      }).then(async () => {
        // 出库的数据
        let data = {
          number: "", // 货号
          num: "", // 数量
          size: "", // 规格
          goods: "", // 箱号
          name: "", // 产品名字
          gck_number: "", // 明细码
          unit: "", // 单位
        };

        this.w_data.map((i) => {
          data.number += (i.goods_number || i.number) + ",";
          data.num += i.goods_count + ",";
          data.name += (i.goods_name || i.name) + ",";
          data.size += (i.goods_normtype || i.size) + "|";
          data.gck_number += i.gck_number + ",";
          data.unit += (i.unit || "") + ",";
        });
        data.goods += this.add_data + ",";
        for (let i in data) {
          data[i] = data[i].substring(0, data[i].length - 1); // 去除最后一个逗号
        }
        let packing = await this.post(this.APIOBJ.doVouch, data);
        if (packing.data.status == 0) {
          this.ware_type = 1;
          Dialog.confirm({
            message: packing.data.msg,
          }).then(async () => {
            // 点了确定 再次入库
            data.type = this.ware_type;
            let packing = await this.post(this.APIOBJ.doVouch, data);
            this.type = "";
            this.ware_type = 0;
          });
        } else {
          this.type = "";
          this.ware_type = 0;
          Toast(packing.data.msg);
        }
      });
    },
    deleteData(i) {
      Dialog.confirm({
        message: "确定要删除当前出库单吗?",
      }).then(() => {
        if (this.type === "true") {
          let data = this.w_data[i];
          let gck_number = data.gck_number;
          let index = this.all_data.indexOf(gck_number);
          this.all_data.splice(index, 1);
          this.w_data.splice(i, 1);
        } else {
          Toast("已入库,不能删除");
        }
      });
    },
    holdRay() {
      this.ray = "扫描中";
      if (this.add_data) {
        // 如果箱号的框有值
        this.$refs.getIDInpot2.focus();
        this.$refs.getIDInpot.setAttribute("readonly", "readonly");
        this.$refs.getIDInpot2.removeAttribute("readonly");
      } else {
        this.focus();
      }
    },
    focus() {
      this.$refs.getIDInpot.focus();
      this.$refs.getIDInpot.setAttribute("readonly", "readonly");
      setTimeout(() => {
        this.$refs.getIDInpot.removeAttribute("readonly");
      }, 200);
    },
    hideMessage() {
      this.ray = "已暂停，点击我继续扫码";
    },
    async add_mx() {
      let flag = true;
      if (!navigator.onLine) {
        Toast("当前网络故障");
        this.add_data = "";
        return;
      }

      await get(this.APIOBJ.isGoods, {
        goods: this.add_data,
      }).then((res) => {
        if (res.data.status == "1") {
          // 如果是1  就说明成功
          this.add_data = res.data.data.goods_num; // 获取货位
          Toast("扫描箱号成功");
        } else {
          flag = false;
          Toast("箱号错误，请重新扫描");
        }
      });
      if (flag) {
        this.$refs.getIDInpot2.focus();
        this.$refs.getIDInpot.setAttribute("readonly", "readonly");
        this.$refs.getIDInpot2.removeAttribute("readonly");
      }
    },

    countAll() {
      this.allNum = 0;
      for (let i of this.w_data) {
        this.allNum += parseFloat(i.goods_count);
      }
    },

    warehousing() {
      if (this.all_data.indexOf(this.mxm) !== -1) {
        this.mxm = "";
        Toast("请勿重复扫码");
        return;
      }
      let flag = false;
      if (this.mxm.indexOf("-") !== -1) {
        this.mxm = this.mxm.split("-")[0];
        flag = true;
      }
      get(this.APIOBJ.vouchOne, {
        goods: this.add_data,
        gck_number: this.mxm,
      }).then((res) => {
        if (res.data.status == "1") {
          if (this.belong === "") {
            this.belong = res.data.data.belong;
          }

          if (this.belong !== res.data.data.belong) {
            Toast(res.data.msg);
            this.mxm = ''
            return;
          }

          Toast("扫描成功");
          let number = this.w_data.map((item) => item.gck_number);
          let index = number.indexOf(this.mxm);
          if (flag) {
            res.data.data.goods_count = 1;
          }
          res.data.data.goods_count = res.data.data.goods_count
            ? res.data.data.goods_count
            : res.data.data.num;
          if (index !== -1) {
            this.w_data[index].goods_count =
              this.w_data[index].goods_count * 1 +
              res.data.data.goods_count * 1;
          } else {
            this.all_data.unshift(this.mxm);
            this.w_data.unshift(res.data.data);
          }
          this.mxm = "";
        } else {
          Toast(res.data.msg);
        }
      });
    },
  },
};
</script>

<style>
.filling-goods-bottom {
  display: flex;
  position: absolute;
  bottom: 0;
  width: 100%;
  margin-left: -10px;
}
.goods-info-two {
  margin-top: 10px;
  background-color: #f2f2f2;
  padding-bottom: 10px;
}
.info-order-h {
  width: 100%;
  display: flex;
  padding-top: 5px;
}
.order-info-input {
  border-radius: 5px;
  border: 1px solid #444444;
  text-align: center;
  width: 4.5rem;
}
.info-order-data {
  width: 65%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.info-order-title {
  width: 35%;
}
</style>